import { getConfig } from '@local/app-config';
import { createApi } from '@reduxjs/toolkit/query/react';

import {
    getCurrentEvoInstance,
    isInstanceOverrideCode,
} from '../../store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { createBentleyAccessTokenBaseQuery } from '../identityClient/requests/BentleyAccessTokenApi';

function getDiscoveryUrlConfig() {
    const currentHub = getCurrentEvoInstance();
    let url = '';
    // Override instances may point at service-specific or local endpoints that cannot serve Bentley
    // identity discovery. Always use the global discovery endpoint for these synthetic instances.
    const isOverrideInstance = isInstanceOverrideCode(currentHub.hub?.code || '');
    if (currentHub.hub && !isOverrideInstance) {
        url = currentHub.hub.url + '/workspace'; // Use hub discovery endpoint
    } else {
        url = getConfig().discovery_url; // Use global discovery endpoint
    }
    return {
        url,
        forceOauthPrefix: false,
    };
}

export const BentleyEntitlementsApiClient = createApi({
    reducerPath: 'bentleyEntitlementsAPI',
    baseQuery: createBentleyAccessTokenBaseQuery(getDiscoveryUrlConfig),
    endpoints: () => ({}),
});
